import { render, staticRenderFns } from "./DbRevisions.vue?vue&type=template&id=190821e6"
import script from "./DbRevisions.vue?vue&type=script&lang=js"
export * from "./DbRevisions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('190821e6')) {
      api.createRecord('190821e6', component.options)
    } else {
      api.reload('190821e6', component.options)
    }
    module.hot.accept("./DbRevisions.vue?vue&type=template&id=190821e6", function () {
      api.rerender('190821e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/audit/DbRevisions.vue"
export default component.exports